import { AGE_2784_REGION_VS_PLACES } from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useRegionVsPlacesExp(): string | undefined {
  const decision = useSpecificOptimizelyUserDecision(AGE_2784_REGION_VS_PLACES)
  return decision?.variationKey ?? undefined
}
